import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Api } from "../../../helpers/Api";
import columnConfig from "../Main/Dashboard/columns";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import {  Form } from "react-bootstrap";

const PastEventView = ({ user, ...props }) => {
    const params = useParams();
    params.path = "PastEventInfo";
    const navigate = useNavigate();

    let config = columnConfig[params.path];
    let tableconfig = columnConfig['templates_2'];

    const [data, setData] = useState();
    const [posts, setPosts] = useState();


    const loadData = (id) => {
        if (id === "new") {
            return;
        }
        
        Api.call(`/templatesdata?id=${id}`)
            .then((post) => {
                setData(post);
                setPosts(post.data)
                setTimeout(() => {
                }, 2000);
            })
            .catch(console.log)
            .finally(() => {
            });
    };

    useEffect(async () => {
        if (params.templateId) {
            loadData(params.templateId);
        }
    }, [params.templateId,config.url]);
  
    return (
        <div className="right_container">
            <div className="dashboard">
                <div className="inner-content">
                    <h4>Event Information</h4>
                    <div className="past-event-view">
                        <div className="past-event-details">
                            {data &&
                                config.data.map((d) => {
                                    if (d.type == "text-array") {
                                        if (d.accessor) {
                                            return (
                                                <div className="view-content">
                                                    <h4>{d.name}</h4>
                                                    {data[d.key].map((a, i) => {
                                                        return (
                                                            <p id={i}>{`${d.accessor(a)}`}</p>
                                                        )
                                                    })}
                                                </div>
                                            )
                                        }
                                        else {
                                            return (
                                                <div className="view-content">
                                                    <h4>{d.name}</h4>
                                                    {data[d.key].map((a, i) => {
                                                        return (
                                                            <p id={`${d.name}${i}`}>{`${a.name}(${a.email},${a.designation})`}</p>
                                                        )
                                                    })}
                                                </div>
                                            )
                                        }
                                    }

                                    if (d.type == "text") {
                                        if (d.accessor) {
                                            return (
                                                <div className="view-content">
                                                    <h4>{d.name} </h4>
                                                    <p>{d.accessor(data[d.key])}</p>
                                                </div>
                                            );
                                        }
                                        else {
                                            return (
                                                <div className="view-content">
                                                    <h4>{d.name} </h4>
                                                    <p>{`${data[d.key]}`}</p>
                                                </div>
                                            );
                                        }
                                    }
                                })}
                        </div>
                        {data && <div className="past-event-image">
                            <img

                                id={`${data['Poster']}`}
                                src={`${data['Poster']}`}
                                alt="Uploaded_Image"
                            />
                        </div>}
                    </div>

                    {posts && <div className="resource-person-view-table">
                        <h4>Templates</h4>
                        <div className="commen-table">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Template Name</th>
                                        <th>Attendence</th>
                                        <th>Created At</th>
                                        <th>Created By</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {posts.map(x => {

                                        return (<tr>
                                            <td>{x.TemplateName}</td>
                                            <td>{x.Attendence}</td>
                                            <td>{x.Created_At}</td>
                                            <td>{x.Updated_By}</td>
                                        </tr>)
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>}

                    {data && <div className="past-gallery">

                        {config.data.map((d) => {
                            if (d.type == "array") {
                                return (
                                    <>
                                        <Form.Label >
                                            {d.name}
                                        </Form.Label>
                                        <div className="galley-thumbnai">
                                            {data[d.key] && data[d.key].map((image, index) => {
                                                return (
                                                    <div className="thumbnail-photo">
                                                        <img

                                                            id={`${index}`}
                                                            src={`${image.imageUrl}`}
                                                            alt="Uploaded_Image"
                                                        />
                                                        <p align="center" style={{color:'#667085'}}>{image.caption}</p>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </>
                                );
                            }
                        })}
                    </div>}

                    {data && data['resource_persons'] && <div className="resource-person-view-table">
                        <h4>Resource persons</h4>
                        <div className="commen-table">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Designation</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data['resource_persons'].map(x => {
                                        return (<tr>
                                            <td>{x.name}</td>
                                            <td>{x.email}</td>
                                            <td>{x.designation}</td>
                                        </tr>)
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>}

                    {data && data['Newss'] && <div className="news-view">
                        <h4>News</h4>
                        <div className="news-data">
                            {data['Newss'].map(x => {
                                return (<a href={x.url.includes('https://')
                                 ? x.url : `https://${x.url}`}>
                                    <span>{x.url}</span>
                                    <img src='../../../../images/arrow-up-right.svg' alt='icon' />
                                </a>)
                            })}
                        </div>
                    </div>}

                    {data && data['Description'] && <div className="description-view">
                        <h4>Description</h4>
                        <div className="description-data">
                            <p>{data['Description']}</p>
                        </div>
                    </div>}

                    <div className='mt-3 Form-buttons'>
                        <button className='cancel' type="button" onClick={() => { navigate(`/${config.cancel_url}`) }} style={{ marginRight: 0 }}>
                            Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};

const mapDispatchToProps = (dispach) => {
    return {
        dispatchLogin: (user) => {
            dispach({ type: "Login", data: user });
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PastEventView);
